import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

interface Project {
  Title: string;
  Description: string;
  Technologies: string[];
  demoLink?: string;
  ghLink?: string;
}

@Component({
  selector: 'app-more-projects',
  templateUrl: './more-projects.component.html',
  styleUrls: ['./more-projects.component.scss']
})
export class MoreProjectsComponent implements OnInit {
  projects: Project[] = [
    {
      "Title": "AutoCursor",
      "Description": "A Python script that automates cursor movement. It utilizes pyautogui to move the cursor automatically on the screen within specified coordinates for every two seconds. This script is useful for keeping systems active or simulating user activity.",
      "ghLink": "https://github.com/Pa1mekala37/Auto-Move-Curser-using-Python",
      "Technologies": [
        "Python",
        "pygui"
      ]
    },
    {
      "Title": "NXT Watch",
      "Description": "Developed NXT Watch, a YouTube clone allowing users to log in, view video categories like Trending and Gaming, search videos, view details, and toggle between Light and Dark themes.",
      "ghLink": "https://github.com/Pa1mekala37/Nxt-Watch",
      "demoLink": "https://pvnnxtwatch.ccbp.tech",
      "Technologies": [
        "React.js",
        "JSX",
        "Authentication",
        "Authorization"
      ]
    },
    {
      "Title": "IPL Dashboard",
      "Description": "Implemented IPL Dashboard using React.js for listing IPL teams, displaying team details, and showing team match information. Utilized React Router for navigation and async fetching of team data from the server.",
      "ghLink": "https://github.com/Pa1mekala37/ReactJs-IPL-Dashboard-App",
      "demoLink": "https://ipldashboardpvn.ccbp.tech",
      "Technologies": [
        "React.js",
        "JSX",
        "Bootstrap",
        "Javascript"
      ]
    },
    {
      "Title": "GoodReads API",
      "Description": "Node.js and Express.js server fetching book information including author, description, and title via RESTful APIs.",
      "ghLink": "https://github.com/Pa1mekala37/CCBP-NodeJs-Goodreads-API",
      "Technologies": [
        "Node.js",
        "Express.js",
        "NPM",
        "REST API"
      ]
    },
    {
      "Title": "SecureKey",
      "Description": "Developed a password manager application using React.js to securely store website names, usernames, and passwords in a list format.",
      "ghLink": "https://github.com/Pa1mekala37/ReactJs-Password-Manager",
      "Technologies": [
        "React.js",
        "JSX",
        "Bootstrap",
        "Javascript"
      ]
    },
    {
      "Title": "Hotstar",
      "Description": "Hotstar Web version Clone Using HTML,CSS,Bootstrap",
      "ghLink": "https://github.com/Pa1mekala37/Disney-Hotstar-Clone",
      "demoLink": "https://hotstar.ccbp.tech",
      "Technologies": [
        "HTML",
        "CSS",
        "Bootstrap"
      ]
    }
  ];

  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  redirect(route: string, event: Event) {
    const id = (event.target as HTMLElement).id;
    if (id === 'demoLink' || id === 'ghLink') {
      return;
    }
    window.open(route, '_blank');
  }
}
